import * as z from "zod";

export const undeclareWasteWorkOrder = {
  name: "undeclareWasteWorkOrder" as const,
  input: z.object({
    workOrderId: z.string(),
    quantity: z.number().int().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
